import React, { useState } from "react";
import './CheckBox.css';

const CheckBoxAR = ({ label, checked, onChange }) => {
    return (
        <label className="checkbox-container arabic-flex">
        <input type="checkbox" checked={checked} onChange={onChange} />
        {/* <span className="checkmark"></span> */}
        {label}
        </label>
    );
};

export default CheckBoxAR;